import { Favourite, CreateFavourite, UpdateFavourite } from 'models/favourite';
import { ApiServiceBase } from './base/api-service-base';

const baseEndpoint = 'favourites';

export class FavouriteApiService extends ApiServiceBase {
  /**
   * Get most favourite items by tenant ID
   */
  async getMostFavourites(): Promise<Favourite[]> {
    return await this.GetFromApi<Favourite[]>(`${baseEndpoint}/most-favourites`);
  }

  /**
   * Get user's favourite items by user ID and tenant ID
   */
  async getUserFavourites(): Promise<Favourite[]> {
    return await this.GetFromApi<Favourite[]>(`${baseEndpoint}/user-favourites`);
  }

  /**
   * Create a new favourite item
   */
  async createFavourite(data: CreateFavourite): Promise<Favourite> {
    return await this.PostToApi<Favourite>(`${baseEndpoint}/create`, data);
  }

  /**
   * Delete a favourite item
   */
  async deleteFavourite(id: number): Promise<void> {
    await this.DeleteFromApi(`${baseEndpoint}/delete/${id}`);
  }
}
